/**
 * Normalizes scopes by deduplicating and sorting them.
 * This creates a canonical representation for comparison.
 *
 * @param scopes - Array of scope strings (may contain duplicates)
 * @returns Normalized, sorted array of unique scopes
 */
export const normalizeScopes = (scopes: string[]): string[] => {
  return [...new Set(scopes)].sort((a, b) => a.localeCompare(b));
};
